import React, { useState } from "react";
import { Popover, MenuItem, Box, Divider, Paper } from "@mui/material";
import exportImg from "../assets/exportImage.svg";
import arrowDownImg from "../assets/drodownImage.svg";
import "../styles/ExportComponent.css";

interface ExportPopoverProps {
  onExport: (fileType: string) => void; // Callback to handle export logic
  isReportExport?: boolean;
}

const ExportComponent: React.FC<ExportPopoverProps> = ({
  onExport,
  isReportExport,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExport = (fileType: string) => {
    onExport(fileType); // Trigger export callback
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "export-popover" : undefined;

  return (
    <div style={{ padding: "0px", margin: "0px" }}>
      {/* Export Button with two images */}
      <Box
        component="div"
        onClick={handleClick}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "space-between", // Space between text and icon
          cursor: "pointer",
          backgroundColor: "#1D4C3D",
          height: "37px",
          borderRadius: "8px",
          paddingLeft: "20px",
          paddingTop: "0px",
          marginTop: "0px",
          marginBottom: "5px",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#1D4C3D",
          },
          width: "135px", // Set the width of the button (adjust based on your needs)
        }}
      >
        {/* Export icon and text */}
        <Box
          sx={{ display: "flex", alignItems: "center", marginRight: "10px" }}
        >
          <img
            src={exportImg}
            alt="Export Icon"
            style={{ marginRight: "15px" }} // Space between export icon and text
          />
          <span className="export-text">Export</span>
        </Box>

        {/* Arrow down icon without padding */}
        <Box
          sx={{
            height: "100%", // Ensure the arrow icon takes the full height of the green container
            width: "40px", // Adjust width for the yellow part
            backgroundColor: "#1D362E", // Different background color for arrow icon
            borderRadius: "0px 8px 8px 0px", // Rounded corners only on the right side
            display: "flex",
            alignItems: "center", // Center the icon vertically
            justifyContent: "center", // Center icon horizontally
            // marginLeft: "10px",
            // paddingLeft: "10px",
          }}
        >
          <img
            src={arrowDownImg}
            alt="Arrow Down Icon"
            style={{
              width: "10px", // Adjust width and height as needed
              height: "10px",
            }}
          />
        </Box>
      </Box>

      {/* Popover with Export Options */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left", // Anchor at the start of the button (green)
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left", // Align popover to the start of the button
        }}
        PaperProps={{
          style: {
            borderRadius: "8px",
            backgroundColor: "#F1B745", // Remove the white box effect by setting the background color here
            boxShadow: "#ffffffff", // Optional: Remove box shadow for a flat look
            width: anchorEl ? anchorEl.offsetWidth : undefined, // Match the width of the popover to the button (green + yellow)
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: 0, // Remove any padding
          }}
        >
          {/* XLS and CSV Menu Items with Divider in the Center */}
          <MenuItem
            onClick={() => handleExport("excel")}
            sx={{
              backgroundColor: "inherit", // Inherit from the parent Box (yellow)
              "&:hover": {
                backgroundColor: "#F1B745",
              },
              padding: "10px 20px", // Add padding to increase touch area
              width: "100%", // Ensure full width
              fontFamily: "Mazzard",
              color: "#292D30",
              fontSize: "14px",
              fontWeight: "500",

              letterSpacing: "0.45",
            }}
          >
            XLSX
          </MenuItem>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ backgroundColor: "#fff" }}
          />
          <MenuItem
            onClick={() => handleExport("csv")}
            sx={{
              backgroundColor: "inherit", // Inherit from the parent Box (yellow)
              "&:hover": {
                backgroundColor: "#F1B745",
              },
              padding: "10px 20px", // Add padding to increase touch area
              width: "100%", // Ensure full width
              fontFamily: "Mazzard",
              color: "#292D30",
              fontSize: "14px",
              fontWeight: "500",
              letterSpacing: "0.45",
            }}
          >
            CSV
          </MenuItem>
        </Box>
      </Popover>

      {/* WHITE TOOLTIP RENDERED **OUTSIDE** POPUP */}
      {open && isReportExport === true && (
        <Box
          sx={{
            position: "absolute",
            top: anchorEl ? anchorEl.getBoundingClientRect().bottom + 40 : 0,
            left: anchorEl ? anchorEl.getBoundingClientRect().left - 195 : 0,
            background: "#fff",
            padding: "10px 14px",
            borderRadius: "10px",
            borderTopRightRadius: "0px",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
            zIndex: "9999",
            width: "330px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <span
              style={{ color: "#1D4C3D", marginRight: "8px", fontSize: "18px" }}
            >
              ⓘ
            </span>
            <div style={{ fontSize: "12px", color: "#292D30", width: "100%" }}>
              This XLSX/CSV contains the individual score of learners for the
              selected assessments.
            </div>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default ExportComponent;
